angular
    .module('webcomm')
    .controller('MainController', [
        '$scope', 
        '$log', 
        '$location', 
        '$filter', 
        '$timeout',
        '$window',
        'channelModel', 
        'connectionService', 
        'muteService',
        'profileModel',
        'privateCallService',
        'endpointModel',
        'authService',
        'connectionHealthService',
        'mapLoaderService',
        'dispositionService',
        function($scope,
                 $log,
                 $location,
                 $filter,
                 $timeout,
                 $window,
                 channelModel,
                 connectionService,
                 muteService,
                 profileModel,
                 privateCallService,
                 endpointModel,
                 authService,
                 connectionHealthService,
                 mapLoaderService,
                 dispositionService) {
            var selectedProfile;
            $scope.privateCallChannels = {};
            $scope.publicChannels = {};
            $scope.numPrivateCalls = 0;
            $scope.connectionInfo = {latency: 0, serverLag: 0}

            // notifications
            $scope.noMicrophoneNotification = $scope.noMicrophone;
            $scope.noMapKeyNotification = !mapLoaderService.mapKey;

            $scope.hideNotification = (prop) => { $scope[prop] = false; };

            function addChannelToModel(channelId) {
                let channel = channelModel.getChannel(channelId);
                $scope.channels[channelId] = channel;
                $scope.publicChannels[channelId] = channel;
            }

            var viewModeBeforeReconnect = null;

            var init = function() {
                $scope.channels = Object.assign({}, $scope.privateCallChannels);

                // take to login page if not logged in
                if (!connectionService.getCurrentUser()) {
                    $scope.logOut();
                    return;
                }

                selectedProfile = profileModel.getSelectedProfile();
                profileModel.getChannelIdsForProfile(selectedProfile.profileId).forEach(channelId => addChannelToModel(channelId));

                $scope.profileMenu.selectedProfileId = selectedProfile.profileId;
                $scope.profileMenu.selectedProfileName = selectedProfile.profileName;

                $log.info('MainController initialized');
            };

            function getMyUserName() {
                var unbindEndpointsUpdated = $scope.$on('endpointModel.presenceUpdated', function(event, data) {
                    if (endpointModel.getMyEndpoint()) {
                        $scope.userName = endpointModel.getMyEndpoint().name;
                        unbindEndpointsUpdated();
                    }
                });
            }

            $scope.inboundCall = false;
            $scope.showSettings = false;
            $scope.showFullMap = false;
            $scope.showStatusSelector = true;
            $scope.viewMode = 'talk-groups';
            $scope.mobile = {
                isMainMenuSelected: true
            }

            $scope.areChannelsAvailable = () => Object.keys($scope.channels).length > 0;
            $scope.areAnyChannelsActive = () => channelModel.areAnyChannelsActive();

            $scope.logOut = function() {
                $location.path(authService.loginPath);
                connectionService.logout();
                $log.debug("mainController.logOut");
            };

            $scope.setViewMode = (mode) => {
                $scope.viewMode = mode;
            };

            $scope.profileMenu = {
                visible: false,
                confirmProfileChange: false,
                selectedProfile: '',
                profiles: profileModel.getProfiles(),
                hasMultipleProfiles: Object.keys(profileModel.getProfiles()).length > 1,
                toggle($event) {
                    this.visible = !this.visible;
                }
            };

            $scope.openProfileSelect = function() {
                $scope.profileMenu.confirmProfileChange = true;
                $scope.profileMenu.visible = false;
            };

            $scope.changeProfile = function() {
                $scope.profileMenu.confirmProfileChange = false;
                if ($scope.profileMenu.selectedProfileId !== selectedProfile.profileId) {
                    $scope.profileMenu.selectedProfileName = selectedProfile.profileName;
                    connectionService.reconnect($scope.profileMenu.selectedProfileId);
                }
                //Reconnect here
            };

            $scope.openSettings = function() {
                $scope.showSettings = !$scope.showSettings;
                $scope.profileMenu.visible = false;
            }

            $scope.mute = {
                isMuted() {
                    return muteService.allChannelsMuted();
                },
                toggleMute() {
                    muteService.allChannelsMuted() ? muteService.unmuteAll() : muteService.muteAll();
                }
            };

            $scope.privateCallCreated = function() {
                $scope.numPrivateCalls++;
            };

            $scope.privateCallRemoved = function() {
                $scope.numPrivateCalls--;
            };

            $scope.callOffer = {
                callInfo: null,
                answering: false,
                answer() {
                    this.answering = true;
                    $log.info('answering call', this.callInfo);
                    privateCallService.callAnswer()
                        .then((call) => {
                            $scope.inboundCall = false;
                            this.answering = false; // reset state since the call was answered
                        });
                },
                close() {
                    if(!this.answering) {
                        this.hangup();
                    }
                },
                hangup() {
                    $log.info('hangup call', this.callInfo);
                    this.answering = false;
                    privateCallService.callHangup(this.callInfo.callId)
                        .then(() => {
                            $scope.inboundCall = false;
                        })
                        .catch((err) => {
                            $log.error(err);
                        });
                }
            };

            // User status dropdown

            $scope.status = {
                isOpen: false,
                selected: 'ready',
                set: function(newStatus) {
                    // This needs to use $q
                    dispositionService.setDisposition(endpointModel.getMyEndpoint().id, newStatus);
                }
            };

            $scope.toggled = function(open) {
                $log.log('Dropdown is now: ', open);

                if(!open){
                   $scope.profileMenu.toggle();
                }
            };

            $scope.toggleDropdown = function($event) {
                $event.preventDefault();
                $event.stopPropagation();
                $scope.status.isOpen = !$scope.status.isOpen;
            };

            // Map

            $scope.googleMapsLoaded = function() {
                let isLoaded = $window['google'];
                //$log.debug("isLoaded: ", isLoaded);
                return isLoaded;
            }

            getMyUserName();

            var unbindProfileNameChanged = $scope.$on('wtcpjsService.profileNameChanged', function(event, profileName) {
                $scope.profileMenu.selectedProfileName = profileName;
            });

            var unbindReconnecting = $scope.$on('isReconnecting', (e, reconnecting, tryAgain) => {
                if(reconnecting) {
                    getMyUserName();
                    viewModeBeforeReconnect = $scope.viewMode;
                    if(viewModeBeforeReconnect === 'contacts') {
                        $scope.viewMode = 'none';
                    }
                } else {
                    $scope.viewMode = viewModeBeforeReconnect;
                }
            })

            var unbindChannelSelected = $scope.$on('channelModel.channelSelected', function(event, channel) {
                $scope.selectedChannelId = channel.id;
                $scope.selectedChannelName = $scope.channels[channel.id].name;
                $scope.mobile.isMainMenuSelected = false;
                $log.debug(`mainController: new channel selected - ${channel.id}`);
            });

            var unbindChannelPropertiesRecieved = $scope.$on('wtcpjsService.channelPropertiesReceived', function(event, channel) {
                $scope.channels[channel.id] = channel;

                if($scope.selectedChannelId && $scope.selectedChannelId === channel.id) {
                    $scope.selectedChannelName = $scope.channels[$scope.selectedChannelId].name;
                }
            });

            var unbindChannelRemoved = $scope.$on('channelModel.channelRemoved', function (event, channelId) {
                delete $scope.channels[channelId];
                //// if the deleted channel was selected - select the first channel
                //if ($scope.channels.keys >  channelId === $scope.selectedChannelId)
                //    channelModel.selectChannel($scope.channels[$scope.channels.keys()[0]].id);
            });

            var unbindPrivateCallChannelsCleared = $scope.$on('channelModel.privateCallChannelsCleared', function () {
                $scope.privateCallChannels = {};
            });

            var unbindChannelsUpdated = $scope.$on('channelModel.channelsCleared', function() {
                $log.info('channelModel.channelsCleared received in mainController');

                $scope.publicChannels = {};
                init();
            });

            var unbindActiveChannelsChanged = $scope.$on('wtcpjsService.activeChannelsChanged', function(event, channels) {
                $log.info('wtcpjsService.activeChannelsChanged received in mainController - ', channels);
                init();
            });

            var unbindPrivateCallChannelAdded = $scope.$on('channelModel.privateCallChannelAdded', function(event, channel) {
                $scope.channels[channel.id] = $scope.privateCallChannels[channel.id] = channel;
            });

            var unbindSettingsClose = $scope.$on('settings.close', function(event) {
                $scope.showSettings = false;
                event.preventDefault();
            });

            var unbindOpenFullscrenMap = $scope.$on('map.openFullscreenMap', function(event) {
                $scope.showFullMap = true;
            });

            var unbindCloseFullscreenMap = $scope.$on('map.closeFullscreenMap', function(event) {
                $scope.showFullMap = false;
            });

            var unbindConnectionInfoUpdated = $scope.$on('connectionHealthService.infoUpdated', function(event, data) {
                //$log.debug('Main controller got connectionHealthService.infoUpdated', data);
                $scope.connectionInfo.latency = data.latency;
            });

            //var unbindMapInit = $scope.$on('mapInitialized', function(event, map) {
            //    $timeout(function() {
            //        $log.debug('map Initialized - resizing');
            //         google.maps.event.trigger(map, 'resize');
            //    }, 500);
            //});

            var unbindSpeaking = $scope.$on('wtcpjsService.endpoint.speaking', function(event, data) {
                $log.debug(`endpoint speaking ${data.started ? 'started' : 'ended'}`);
            });

            var unbindMakingCall = $scope.$on('makingCall', function(e, data) {
                $scope.setViewMode('talk-groups');
            });

            var unbindCallOfferReceived = $scope.$on('privateCallService.callOfferReceived', (e, data) => {
                $scope.callOffer.callInfo = data;
                $scope.inboundCall = true;
            });
            
            var unbindCallHangupReceived = $scope.$on('privateCallService.callHangupReceived', () => {
                $scope.inboundCall = false;
                $scope.callOffer.answering = false;
            });

            var unbindPrivateCallChannelClosed = $scope.$on('privateCallChannelClosed', (e, channel) => {
                if($scope.selectedChannelId === channel.id)
                    for(var c in $scope.channels) {
                        channelModel.selectChannel(c);
                        break;
                    }
            });

            var unbindDispositionSet = $scope.$on('dispositionService.dispositionSet', (e, disposition) => {
                $scope.status.selected = disposition.toLowerCase();
                if(disposition === 'Phone') {
                    $scope.showStatusSelector = false;
                } else {
                    $scope.showStatusSelector = true;
                }
            });

            var unbindIdleStart = $scope.$on('IdleStart', () => {
                let _myEndpoint = endpointModel.getMyEndpoint();
                if(_myEndpoint.disposition !== 'Phone') {
                    dispositionService.setDisposition(endpointModel.getMyEndpoint().id, 'Idle');
                }
            });

            var unbindIdleEnd = $scope.$on('IdleEnd', () => {
                let _myEndpoint = endpointModel.getMyEndpoint();
                if(_myEndpoint.disposition !== 'Phone') {
                    dispositionService.setDisposition(endpointModel.getMyEndpoint().id, 'Ready');
                }
            });

            $scope.$on('$destroy', function() {
                unbindPrivateCallChannelsCleared();
                unbindReconnecting();
                unbindPrivateCallChannelClosed();
                unbindCallHangupReceived();
                unbindCallOfferReceived();
                unbindChannelSelected();
                unbindChannelsUpdated();
                unbindChannelPropertiesRecieved();
                unbindSettingsClose();
                unbindProfileNameChanged();
                unbindChannelRemoved();
                unbindOpenFullscrenMap();
                unbindCloseFullscreenMap();
                unbindActiveChannelsChanged();
                //unbindMapInit();
                unbindSpeaking();
                unbindMakingCall();
                unbindPrivateCallChannelAdded();
                unbindConnectionInfoUpdated();
                unbindDispositionSet();
                unbindIdleStart();
                unbindIdleEnd();
                $log.debug('MainController destroyed');
            })();

            init();
        }
    ])
    .config(["IdleProvider", function(IdleProvider) {
        IdleProvider.idle(300);
        IdleProvider.timeout(false);
    }])
    .run(['Idle', function(Idle) {
        Idle.watch();
    }]);
   
